export default __webpack_public_path__ + "static/media/syrie_carte_1-min_FR.888e0dcc.png";